/*
 * Baskas Availability Badges — Shows real-time inventory on product cards
 * Lightweight script for homepage/collection pages
 */
(function () {
  'use strict';

  var API = window.__baskasRentalApi;
  if (!API) return;

  /* Model detection from product card link/title */
  var CARD_MODEL_MAP = {
    'soundboks-go': 'GO', 'soundboks go': 'GO', 'go': 'GO',
    'soundboks-2': 'SB2', 'soundboks 2': 'SB2',
    'soundboks-3': 'SB3', 'soundboks 3': 'SB3',
    'soundboks-4': 'SB4', 'soundboks 4': 'SB4',
  };

  function detectModelFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var title = card.querySelector('.product-grid-item__title, .product-card__title, h3, h4');
    var text = ((link && link.href) || '') + ' ' + ((title && title.textContent) || '');
    text = text.toLowerCase();

    for (var key in CARD_MODEL_MAP) {
      if (text.indexOf(key) !== -1) return CARD_MODEL_MAP[key];
    }
    return null;
  }

  function getMonthStr() {
    var d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
  }

  function injectBadge(card, model) {
    /* Don't inject twice */
    if (card.querySelector('.bk-card-badge')) return;

    fetch(API + '/api/availability/' + model + '?month=' + getMonthStr())
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var days = data.days || [];
        var today = new Date().toISOString().slice(0, 10);

        /* Find min availability in next 14 days */
        var minAvail = 999;
        var availDays = 0;
        for (var i = 0; i < days.length; i++) {
          if (days[i].date >= today) {
            if (!days[i].blocked) availDays++;
            minAvail = Math.min(minAvail, days[i].available);
          }
        }
        if (minAvail === 999) return;

        var badge = document.createElement('div');
        badge.className = 'bk-card-badge';

        if (minAvail <= 0) {
          badge.className += ' bk-card-badge--out';
          badge.textContent = 'Udsolgt denne måned';
        } else if (minAvail <= 2) {
          badge.className += ' bk-card-badge--low';
          badge.textContent = 'Kun ' + minAvail + ' ledige';
        } else {
          badge.className += ' bk-card-badge--ok';
          badge.textContent = minAvail + ' ledige';
        }

        /* Insert at top of card or after image */
        var imgWrap = card.querySelector('.product-grid-item__image, .product-card__image, a');
        if (imgWrap) {
          imgWrap.style.position = 'relative';
          badge.style.position = 'absolute';
          badge.style.bottom = '8px';
          badge.style.left = '8px';
          badge.style.zIndex = '5';
          imgWrap.appendChild(badge);
        } else {
          card.prepend(badge);
        }
      })
      .catch(function () { /* Silently fail — badges are enhancement only */ });
  }

  function init() {
    /* Find product cards on the page */
    var cards = document.querySelectorAll('.product-grid-item, .product-card, [data-product-card]');
    cards.forEach(function (card) {
      var model = detectModelFromCard(card);
      if (model) injectBadge(card, model);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
